module.exports = __webpack_public_path__ + "static/obayemi-b2fe77b46cff2967806156994f3f84f1.png";